<template>
  <v-dialog v-model="visible" :max-width="maxWidth" persistent>
    <v-card>
      <v-card-title>{{ titulo }}</v-card-title>

      <v-divider class="my-0"></v-divider>

      <v-card-text class="pa-4">
        <p v-html="mensaje"></p>

        <slot></slot>
      </v-card-text>

      <v-divider class="my-0"></v-divider>

      <v-card-actions>
        <v-btn color="blue darken-1" text @click.prevent="cerrar" :disabled="realizandoAccion"> Cancelar </v-btn>

        <v-btn
          color="blue darken-1"
          text
          :disabled="realizandoAccion"
          :loading="realizandoAccion"
          @click.prevent="aceptar">
          Aceptar
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'ConfirmacionAccion',
  props: {
    titulo: {
      type: String,
      default: '',
    },
    mensaje: {
      type: String,
      default: '',
    },
    realizandoAccion: {
      type: Boolean,
      default: false,
    },
    maxWidth: {
      type: [String, Number],
      default: 500,
    },
  },
  data() {
    return {
      visible: false,
    };
  },
  methods: {
    abrir() {
      this.visible = true;
    },
    cerrar() {
      this.visible = false;

      this.$emit('cerrar');
    },
    aceptar() {
      this.$emit('aceptar');
    },
  },
};
</script>